"use strict";
var moment = require("moment");
var constants_1 = require("./constants");
function depositDateValidator() {
    return function (control) {
        // deposit date must be a valid date
        var value = control.value;
        if (value && value !== '') {
            var dateValue = moment(value, constants_1.Constants.DATE_PARSE_FORMAT);
            if (!dateValue.isValid()) {
                return { 'invalid': value };
            }
            // deposit date must be on or before today
            if (dateValue.startOf('day').isAfter(moment().startOf('day'))) {
                return { 'afterToday': value };
            }
        }
        return null;
    };
}
exports.depositDateValidator = depositDateValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/deposit-date.validator.js